import React from 'react';
import { PDFDownloadLink, PDFViewer, pdf } from '@react-pdf/renderer';
import { saveAs } from 'file-saver';
import ModalBody, { ModalProps } from './ModalBody';
import { capitalizeFirstLetter } from '../../utils/capitalize';
import { useTranslation } from 'react-i18next';

interface PDFModalProps extends ModalProps {
    PDFComponent: React.FC<any>;
    pdfProps?: Record<string, any>;
    fileName?: string;
    viewerHeight?: number | string;
    viewerWidth?: number | string;
}

const PDFModal: React.FC<PDFModalProps> = ({
    handleClose,
    open,
    PDFComponent,
    pdfProps = {},
    fileName = 'document.pdf',
    viewerHeight = 2500,
    viewerWidth = '100%',
}) => {
    const { t } = useTranslation();
    const doc = <PDFComponent {...pdfProps} />;

    const handleDownload = async () => {
        const blob = await pdf(doc).toBlob();
        saveAs(blob, fileName);
        handleClose();
    };

    return (
        <ModalBody
            title={fileName}
            open={open}
            handleClose={handleClose}
            okText={capitalizeFirstLetter(t('download'))}
            handleOk={handleDownload}
            width={'100%'}
        >
            <PDFViewer width={viewerWidth} height={viewerHeight}>
                {doc}
            </PDFViewer>
        </ModalBody>
    );
};

export default PDFModal;
